import { useEffect, useState } from "react";
import API from "../lib/api";

export function useProfessions() {
  const [professions, setProfessions] = useState([]);
  useEffect(() => {
    API.get("/taxonomy/professions").then(({ data }) => setProfessions(data.professions)).catch(() => {});
  }, []);
  return professions;
}
